import { Pipe, PipeTransform } from '@angular/core';
import { Fields } from '@k2/common/k2-forms-state/types';
import { pickBy } from 'ramda';

@Pipe({
    name: 'pickCustomFields',
    standalone: false
})
export class PickCustomFieldsPipe implements PipeTransform {
  transform(fields: Fields): Fields {
    return pickBy((value, key) => key.startsWith('custom_field_'), fields);
  }
}
